import { notification } from "antd";

export function openNotification(
  title: string,
  message: string,
  level?: "normal" | "error" | "success",
) {
  const content = {
    message: title,
    description: message,
  };
  if (level === "error") {
    notification.error(content);
  } else if (level === "success") {
    notification.success(content);
  } else {
    notification.open(content);
  }
}
